export enum InputType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  DROPDOWN = 'dropdown',
  SWITCH = 'switch',
  TREESELECT = 'treeselect',
  DATEPICKER = 'datepicker',
  AUTOCOMPLETE = 'autocomplete',
  PHONE = 'phone',
  CHECKBOX = 'checkbox',
  UPLOAD = 'upload',
}

export type ErrorType = {
  status: number;
  statusText: string;
  url: string;
  body: {
    errorCode: string;
    timestamp: string;
    metadata?: Record<string, any>;
    message?: string[];
    statusCode?: number;
  };
};
